export const DEMO_PAGE_ROUTE = "/demo";
export const SIGNUP_PAGE_ROUTE = "/signup";
export const SIGNIN_PAGE_ROUTE = "/signin";
export const NOTES_ROUTE = "/notes";
